import React from "react";
import { MessageCircle } from "lucide-react";
import { BUSINESS } from "../constants";

export const WhatsAppFloat = ({ label }) => {
  return (
    <a
      href={BUSINESS.whatsappHref}
      target="_blank"
      rel="noreferrer"
      aria-label={label}
      className="fixed bottom-6 right-6 z-50 group inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1fbb59] text-white pl-4 pr-5 py-3.5 rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-all duration-300 hover:scale-[1.03]"
      data-testid="whatsapp-float-btn"
    >
      <span className="relative flex items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 opacity-40 animate-ping" />
        <MessageCircle className="w-5 h-5 relative" />
      </span>
      <span className="font-heading uppercase text-xs tracking-wider hidden sm:inline">
        {label}
      </span>
    </a>
  );
};
